import React from 'react';
import { connect } from "react-redux";
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import TransactionDetailsTable from './../Components/TransactionDetailsTable/TransactionDetailsTable.js';
import { ColumnHeader } from './../Components/BalanceDetailsTable/styles.js';
import TitleNode from './../Components/CardComponent/TitleNode.js';
import CardComponent from './../Components/CardComponent/CardComponent.js';
import { DataVal, TxnVal } from './../Components/CardComponent/styles.js';
import formatter from './../../../utils/formatter';
import { selectHeader } from "../../../actions/globalActions";
import Highlighter from "react-highlight-words"
import { milliToDate, recordError } from './../../../utils/commonUtil';
import { sortAsNegativeSymbol } from './../../../utils/sorter';
import { TableData } from './TransactionDetailsTable/styles.js';
import history from "../../../history/history";
import { renderDate } from "../Pages/txnUitls";

const getDisplayAmount = (amount, data) => {
  let displayAmount = amount;
  if (data.decrease) {
    displayAmount = `(${amount})`;
  } else {
    displayAmount = amount;
  }
  return displayAmount;
}

const renderAmount = (text, data, searchText) => {
  if (text && text !== "-") {
    let amount = formatter({
      value: text,
      fieldSuffix: 'Dollars',
    })
    const displayAmount = getDisplayAmount(amount, data)
    return (
      <TableData>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={displayAmount}>
          {displayAmount}
        </Highlighter>
      </TableData>);
  } else {
    return <TableData>{(text === 0 ? '$0.00' : '-')}</TableData>;
  }
}

const renderText = (text, searchText) => {
  if (text) {
    return (
      <TableData>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text}>
          {text}
        </Highlighter>
      </TableData>
    )
  } else {
    return <TableData>-</TableData>
  }

}

const renderTxnView = function (txnId, searchText) {
  if (txnId) {
    return (
      <TxnVal isDisabled={false} onClick={() => viewOtherTransaction(txnId)}>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={txnId}>
          {txnId}
        </Highlighter>
      </TxnVal>
    )
  } else {
    return <TxnVal>-</TxnVal>
  }
}

const renderTxnViewMob = function (txnId, searchText) {
  if (txnId) {
    return (
      <>
        <TxnVal isDisabled={false} onClick={() => viewOtherTransaction(txnId)}>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={txnId}>
            {txnId}
          </Highlighter>
        </TxnVal>
      </>
    )
  } else {
    return (
      <>
        <TitleNode title="Transaction ID" />
        <TxnVal>-</TxnVal>
      </>
    )
  }
}

const renderTitleGrid = (pool, searchText) => {
  return (
    <>
      <TitleNode title="Entered Date" />
      <DataVal>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={milliToDate(pool)}>
          {milliToDate(pool)}
        </Highlighter>
      </DataVal>
    </>
  );
}

const renderFixGrid = ({ each, gridName, type }, searchText) => {
  switch (type) {
    case 'date':
      return (
        <>
          <TitleNode title={gridName} />
          {
            (each[gridName] !== null && each[gridName] !== undefined)
              ?
              <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={milliToDate(each[gridName])}>
                  {milliToDate(each[gridName])}
                </Highlighter>
              </DataVal>
              : '-'
          }
        </>
      )
    case 'amount':
      let dollarsAmount = formatter({
        value: each[gridName],
        fieldSuffix: 'Dollars',
      });
      const displayAmount = getDisplayAmount(dollarsAmount, each)
      return (
        <>
          <TitleNode title={gridName} />
          {
            (each[gridName] !== null && each[gridName] !== undefined)
              ? <DataVal>
                <Highlighter
                  highlightStyle={{
                    color: "black",
                    fontWeight: 600,
                    backgroundColor: "transparent"
                  }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={displayAmount}>
                  {displayAmount}
                </Highlighter>
              </DataVal>
              : '-'
          }
        </>
      )
    default:
      return (
        <>
          <TitleNode title={gridName} />
          <DataVal>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={each[gridName]}>
              {each[gridName]}
            </Highlighter>
          </DataVal>
        </>
      );
  }
}



export const viewOtherTransaction = (id) => {
  try {
    history.push({
      pathname: "/my-account/other-transaction",
      state: {
        transactionId: id,
      }
    });
  } catch (error) {
    recordError(error);
  }
};


export const OtherTransactionsTable = ({ searchText, otherTransactionsData }) => {

  const columns = [
    {
      title: <ColumnHeader>Transaction ID</ColumnHeader>,
      render: (txnId) => renderTxnView(txnId, searchText),
      dataIndex: 'transactionId',
      key: 'transactionId',
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.transactionId.localeCompare(b.transactionId) }
    },
    {
      title: <ColumnHeader>Entered Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: 'enteredDate',
      key: 'enteredDate',
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.enteredDate - b.enteredDate }
    },
    {
      title: <ColumnHeader>Description</ColumnHeader>,
      render: (text) => renderText(text, searchText),
      dataIndex: 'description',
      key: 'description',
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.description.localeCompare(b.description) }
    },
    {
      title: <ColumnHeader>Type</ColumnHeader>,
      render: (text) => renderText(text, searchText),
      dataIndex: 'type',
      key: 'type',
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.type.localeCompare(b.type) }
    },
    {
      title: <ColumnHeader>Dollar amount</ColumnHeader>,
      render: (text, data) => renderAmount(text, data, searchText),
      dataIndex: 'amount',
      key: 'amount',
      width: 130,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => {
        return sortAsNegativeSymbol(Math.abs(a.amount), Math.abs(b.amount), a.decrease, b.decrease);
      }
    },
    {
      title: <ColumnHeader>Trade Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: 'tradeDate',
      key: 'tradeDate',
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.tradeDate - b.tradeDate }
    }
  ];

  const destObj = (each) => {
    return [
      {
        name: 'transactionId',
        type: 'FixGrid',
        gridWidth: '100',
        render: renderTxnViewMob(each['transactionId'], searchText),
        ptop: true,
        pbottom: true,
        pleft: true,
      },
      {
        name: "enteredDate",
        gridWidth: '100',
        type: 'FixGrid',
        render: renderTitleGrid(each.enteredDate, searchText),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'description',
        type: 'FixGrid',
        gridWidth: '50',
        render: renderFixGrid({ each, gridName: 'description' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true,
      },
      {
        name: 'type',
        type: 'FixGrid',
        gridWidth: '50',
        render: renderFixGrid({ each, gridName: 'type' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true,
      },
      {
        name: 'dollarAmountOfFee',
        type: 'FixGrid',
        gridWidth: '50',
        render: renderFixGrid({ each, gridName: 'amount', type: 'amount' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true,
      },
      {
        name: 'tradeDate',
        type: 'FixGrid',
        gridWidth: '50',
        render: renderFixGrid({ each, gridName: 'tradeDate', type: 'date' }, searchText),
        ptop: true,
        pbottom: true,
        pleft: true,
      }
    ];
  }
  
  return (
    <Row id="table-search-otherTransactions" data-test="other-transactions-table">
      <Col lg={24} md={0} xs={0}>
        <TransactionDetailsTable data-test="other-transactions-table-desktop" className="otherTransactionTab" tabIdentifier="OtherTransactions" tabName="other_transactions" scroll={{ y: 500 }} columns={columns} data={otherTransactionsData} searchText={searchText} />
      </Col>
      <Col lg={0} md={24} xs={24} className="mobCard">
        <CardComponent data-test="other-transactions-table-mobile" tabName="other_transactions" destObj={destObj} data={otherTransactionsData} searchText={searchText} />
      </Col>
    </Row>
  )
}

OtherTransactionsTable.propTypes = {
  searchText: PropTypes.string,
  otherTransactionsData: PropTypes.array
}

const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data)),
  };
};
export default connect(null, mapDispatchToProps)(OtherTransactionsTable);